// components/TopBar.jsx
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/TopBar.css";

const TopBar = () => {
  const { pathname } = useLocation();
  const isHome = pathname === "/";
  const [pastIntro, setPastIntro] = useState(false);

  // On the home page the bar stays out of the way until the intro has
  // scrolled off screen, then floats in over the content.
  useEffect(() => {
    if (!isHome) return;

    const intro = document.getElementById("home-intro");
    if (!intro || typeof IntersectionObserver === "undefined") {
      setPastIntro(true);
      return;
    }

    setPastIntro(false);
    const observer = new IntersectionObserver(
      ([entry]) => setPastIntro(!entry.isIntersecting),
      { threshold: 0 },
    );

    observer.observe(intro);
    return () => observer.disconnect();
  }, [isHome]);

  const hidden = isHome && !pastIntro;

  return (
    <div
      className={`top-bar${isHome ? " top-bar-floating" : ""}${hidden ? " top-bar-hidden" : ""}`}
      aria-hidden={hidden}
    >
      <div className="top-bar-contents">
        <Link to="/" className="home-link" tabIndex={hidden ? -1 : undefined}>
          <span className="site-title">Arthur Efremenko</span>
        </Link>
      </div>
    </div>
  );
};

export default TopBar;
